import React from "react";
import {Search, Filter} from "lucide-react";
import AppleSelect from "../Common/AppleSelect";
import ActiveFilters from "../Common/ActiveFilters";

/**
 * Zone de recherche des onglets du catalogue (catégories, marques, remises),
 * même style que celle de l'onglet Produits (ProductList) : champ de
 * recherche, filtre de statut optionnel, puis barre « Filtres actifs » (Common/ActiveFilters) avec
 * une puce par filtre appliqué et le bouton pour tout effacer.
 *
 * value / onChange : texte saisi ; activeSearch : recherche appliquée (après
 * debounce, depuis l'URL) ; onClear : vide la recherche.
 * status ('' | 'true' | 'false') / onStatusChange : filtre actif/inactif,
 * affiché seulement si onStatusChange est fourni. onClearAll : vide tout
 * (par défaut onClear).
 */
const CatalogSearchBar = ({
    value,
    onChange,
    activeSearch,
    onClear,
    placeholder = "Rechercher par nom",
    status = "",
    onStatusChange,
    onClearAll,
}) => {
    const hasStatus = !!onStatusChange && status !== "";
    const clearAll = onClearAll || onClear;

    return (
        <>
            <div className="flex flex-col sm:flex-row">
                <div className="relative flex-1">
                    <Search className="w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"/>
                    <input
                        type="text"
                        placeholder={placeholder}
                        className="w-full pl-10 pr-4 py-3 border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary focus:border-primary transition-all placeholder:text-gray-400 shadow-sm"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </div>
                {onStatusChange && (
                    <div className="flex sm:w-52">
                        <AppleSelect
                            variant="toolbar"
                            icon={Filter}
                            aria-label="Statut"
                            value={status}
                            onChange={(e) => onStatusChange(e.target.value)}
                            className="w-full appearance-none pl-10 pr-9 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 focus:ring-2 focus:ring-primary focus:border-primary shadow-sm hover:shadow transition-all cursor-pointer"
                        >
                            <option value="">Tous les statuts</option>
                            <option value="true">Actifs</option>
                            <option value="false">Inactifs</option>
                        </AppleSelect>
                    </div>
                )}
            </div>

            <ActiveFilters
                onClearAll={clearAll}
                chips={[
                    activeSearch && {key: "search", label: `Recherche: ${activeSearch}`, onRemove: onClear},
                    hasStatus && {key: "status", label: `Statut: ${status === "true" ? "Actif" : "Inactif"}`, onRemove: () => onStatusChange("")},
                ].filter(Boolean)}
            />
        </>
    );
};

export default CatalogSearchBar;
